import { DivProps } from '@commonTypes'
import React, { FC } from 'react'
import cx from 'classnames'
import css from './card.module.scss'

type CardT = {
  Header: typeof Header
  Footer: typeof Footer
}

const Card: CardT & FC<React.PropsWithChildren<DivProps>> = (props) => {
  return <div {...props} />
}

const Header: FC<React.PropsWithChildren<DivProps>> = ({ className, ...props }) => {
  return <div className={cx(css.header, className)} {...props} />
}

const Footer: FC<React.PropsWithChildren<DivProps>> = ({ className, ...props }) => {
  return <div className={cx(css.footer, className)} {...props} />
}

Card.Header = Header
Card.Footer = Footer

export default Card
